import { render, staticRenderFns } from "./CheckBoxPop.vue?vue&type=template&id=80987cae&scoped=true"
import script from "./CheckBoxPop.vue?vue&type=script&lang=js"
export * from "./CheckBoxPop.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxPop.vue?vue&type=style&index=0&id=80987cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80987cae",
  null
  
)

export default component.exports